import {useCallback, useEffect, useRef, useState} from "react";
import {COUNTRY_SCOPE_STORAGE_KEY, resolveAdminCountryScope} from "../../shared/api/countryScope";

const EMPTY_COUNTRY_IDS = [];

const concreteCountryId = (value) => {
    const normalized = String(value ?? "").trim();
    return /^[1-9]\d*$/.test(normalized) ? normalized : null;
};

export const useDeployerCountryScope = (capabilities) => {
    const role = capabilities.user?.role;
    const allowedCountryIds = capabilities.scope?.country_ids || EMPTY_COUNTRY_IDS;
    const resolveScope = useCallback((storedScope) => resolveAdminCountryScope({
        role,
        allowedCountryIds,
        storedScope,
    }), [allowedCountryIds, role]);
    const [countryScope, setCountryScope] = useState(() =>
        resolveScope(localStorage.getItem(COUNTRY_SCOPE_STORAGE_KEY)),
    );
    const activeCountryScopeRef = useRef(countryScope);

    useEffect(() => {
        const handleCountryChange = (event) => {
            const nextScope = resolveScope(event.detail?.countryId);
            activeCountryScopeRef.current = nextScope;
            setCountryScope(nextScope);
        };
        window.addEventListener("sorpa-admin-country-scope-change", handleCountryChange);
        return () => window.removeEventListener("sorpa-admin-country-scope-change", handleCountryChange);
    }, [resolveScope]);

    return {countryScope, countryId: concreteCountryId(countryScope), activeCountryScopeRef};
};
